import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { trpc } from '@/lib/trpc'
import { useQuery } from '@tanstack/react-query'
import { ScopeV1Wizard } from '@/components/screenata/ScopeV1Wizard'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/screenata/scope-confirm',
)({
  component: ScopeConfirmPage,
})

function ScopeConfirmPage() {
  const { workspaceId } = useParams({
    from: '/(protected)/workspaces/$workspaceId/screenata/scope-confirm',
  })
  const navigate = useNavigate()

  const programQuery = useQuery(
    trpc.complianceProgram.getProgram.queryOptions({ framework: 'SOC2' }),
  )

  if (programQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-600" />
      </div>
    )
  }

  const program = programQuery.data
  if (!program) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        No compliance program found.
      </div>
    )
  }

  return (
    <ScopeV1Wizard
      programId={program.id}
      onComplete={() => {
        // Triage-enabled programs go to policies hub; legacy programs go to test-outline
        const destination = program.claimTriageEnabled
          ? '/workspaces/$workspaceId/screenata/generate-policies'
          : '/workspaces/$workspaceId/screenata/test-outline'
        navigate({
          to: destination,
          params: { workspaceId },
        })
      }}
    />
  )
}
